import { render, staticRenderFns } from "./AddPointsSelectPrograms.vue?vue&type=template&id=7af25541&scoped=true&"
import script from "./AddPointsSelectPrograms.vue?vue&type=script&lang=js&"
export * from "./AddPointsSelectPrograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af25541",
  null
  
)

export default component.exports